var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.764 21.764H26.237V10.237c0-2.982-4.473-2.982-4.473 0v11.527H10.237c-2.983 0-2.983 4.473 0 4.473h11.527v11.527c0 2.98 4.473 2.98 4.473 0V26.237h11.527c2.982 0 2.982-4.473 0-4.473",
    fill: "currentColor"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCI+PHBhdGggZD0iTTM3Ljc2NCAyMS43NjRIMjYuMjM3VjEwLjIzN2MwLTIuOTgyLTQuNDczLTIuOTgyLTQuNDczIDB2MTEuNTI3SDEwLjIzN2MtMi45ODMgMC0yLjk4MyA0LjQ3MyAwIDQuNDczaDExLjUyN3YxMS41MjdjMCAyLjk4IDQuNDczIDIuOTggNC40NzMgMFYyNi4yMzdoMTEuNTI3YzIuOTgyIDAgMi45ODItNC40NzMgMC00LjQ3MyIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+Cg==";
export { SvgAdd as ReactComponent };